import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import i18n from './translation/i18n';
import { I18nextProvider } from 'react-i18next';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { AppProvider } from './contexts/app.context';
import { ConfigProvider } from 'antd';
import lightTheme from './theme';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <I18nextProvider i18n={i18n}>
          <ConfigProvider
            getPopupContainer={() => document.getElementById('root')!}
            // componentSize='small'
            theme={lightTheme}
            form={{ colon: false }}
          >
            <App />
          </ConfigProvider>
        </I18nextProvider>
      </AppProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </BrowserRouter>
);

serviceWorkerRegistration.register();
